export const getSlugWithoutLocale = (fullslug: string): string => {
  if (!fullslug) return "";

  const slug = fullslug.startsWith("/") ? fullslug.slice(1) : fullslug;

  return slug.split("/").slice(1).join("/");
};
